import React, { useEffect, useState } from "react";
import Translations from "../../services/translation.service";
import StorefrontTitle from "../shared/storefront-title.component";
import ZigZag from "../../assets/img/Bottomzigzag.svg";
import SpinnerTimeLoader from "../shared/timeLoading";
import Storage from "../../services/storage.service";
import Helpers from "../../helpers/shared.helper";
import BillClosedIcon from "../../assets/img/BillClosed.svg";
import BillOpenIcon from "../../assets/img/BillOpenIcon.svg";
import ChangePlanArrow from "../../assets/img/ChangePlanArrow.svg";
import QuestionCircleIcon from "../../assets/img/QuestionCircle.svg";
import BillWalletIcon from "../../assets/img/BillWallet.svg";
import BillPaymentService from "../../services/bill-payment.service";
import CommonPayment from "../shared/commonPayments/common-payment-index";
import moment from 'moment';
import SharedAmount from "../shared/sharedFields/amount";
import ModalWrapper from "../shared/modal-wrapper";
import ContentSlider from "../shared/contentSlider";
import { saveAs } from 'file-saver';
import FirebaseAnalytics from "../../services/analytics.service";
import storefront from "../../services/storefront.service";
import CONSTANTS from "../../services/constants.service";
import "moment/locale/ar-sa";
import "moment/locale/en-ca";

const subscriptions = [];
const BillPaymentBills = props => {
  const { history } = props;
  const [translationKeys, setTranslationsKeys] = useState(
    Translations.keys ? Translations.keys : {}
  );
  const [loading, setLoading] = useState(true);
  const [subLoading, setSubLoading] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const [invoicesList, setInvoicesList] = useState([]);
  const [mappedTotalDueAmount, setMappedTotalDueAmount] = useState({});
  const [mappedPendingInvoiceDetails, setMappedPendingInvoiceDetails] = useState({});
  const [expandedInvoice, setExpandedInvoice] = useState(null);
  const [subExpandedInvoice, setSubExpandedInvoice] = useState(null);
  const [invoiceDetails, setInvoiceDetails] = useState({});
  const [allPlans, setAllPlans] = useState(null);
  const [infoModalDetails, setInfoModalDetails] = useState({
    imagesFolder: "",
    sliderData: [],
  });
  const [openModal, setOpenModal] = useState(false);
  // Prepare Data for TAP Payment
  const [tapPayload, setTapPayload] = useState({
    paymentData: {
      number: null,
      amount: 0,
    },
    apiEndpoint: {
      endpoint: "/postpaid_bills/pay_with_new_card_web",
      method: "post"
    },
    extraInformation: {
      totalAmount: 0,
      payingFor: "bill_payment",
      showAppDownloads: true,
      showPaymentLogos: true
    }
  });

  const [amountFormValues, setAmountFormValues] = useState({
    submitLoader: false,
    amount: {
        value: "",
        touched: false,
        valid: true,
        error: "",
        validation: {
          required: true,
          minAmount: true,
          minAmountValue: 25,
          maxAmount: true,
          maxAmountValue: 2500,
        }
    }
  });

  // Prepare Data for Apple Pay
  const [applePayload, setApplePayload] = useState({
    paymentData: {
      number: null,
      amount: 0
    },
    apiEndpoint: {
      endpoint: "/postpaid_bills/pay_with_apple_web",
      successURL: "/join/#/confirmation-apple-bill-payment",
      failureURL: "/join/#/apple-pay-bill-payment-failure",
      method: "post"
    },
    extraInformation: {
      totalAmount: 0,
      payingFor: "bill_payment",
      showAppDownloads: false,
      showPaymentLogos: false,
    }
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    subscriptions.push(
      Translations.getKeysObsrv().subscribe((data) => {
        setTranslationsKeys(data);
      })
    );

    return () => {
    if (subscriptions && subscriptions?.length) {
        for (let subscription of subscriptions) {
        subscription.unsubscribe();
        }
    }
    };
  }, []);

  useEffect(() => {
    const minimum_bill_payment_amount = Helpers.getPOValue("minimum_bill_payment_amount", 25);
    const maximum_bill_payment_amount = Helpers.getPOValue("maximum_bill_payment_amount", 2500);
    
    setAmountFormValues(prevState => ({
      ...prevState, 
      amount: {
        ...prevState.amount,
        validation: {
          ...prevState.amount.validation,
          minAmountValue: minimum_bill_payment_amount,
          maxAmountValue: maximum_bill_payment_amount
        }
      }
    }));
  }, [])

  const getBillList = (number) => {
    Storage.set("genericAPIError", true);
    setLoading(true);
    let no_of_bills = Helpers.getPOValue("no_of_requested_postpaid_bills", 20);

    setTapPayload(prevState => ({
      ...prevState,
      paymentData: {
        ...prevState.paymentData,
        number: number,
      }
    }));

    setApplePayload(prevState => ({
      ...prevState,
      paymentData: {
        ...prevState.paymentData,
        number: number,
      }
    }));
    
    BillPaymentService.billList(number, no_of_bills)
      .then((response) => {
        if (response) {
          // setLoading(false);
          let data = response.data;
          if(data && data.InvoicesList.length) {
            // List of all invoices
            const openInvoices = data?.InvoicesList?.filter(invoice => invoice.Status === "Open");
            setInvoicesList(openInvoices.reverse());
            if(openInvoices.length > 0) {
              // Fetch Bill Amount from All Open/Pending Invoices
              const invoiceNumbers = openInvoices.map(invoice => invoice.InvoiceNo).join(',');
              BillPaymentService.billByInvoice(invoiceNumbers)
              .then((response) => {
                if (response) {
                  // Mapping TotalDueAmount with InvoiceNo
                  if(response.data.PendingInvoiceDetails) {
                    let responseData = response.data.PendingInvoiceDetails;
                    const getMostRecentInvoice = responseData[responseData.length - 1];
                    let amountToBePaid = getMostRecentInvoice?.TotalDueAmount;
                    const mappedTotalDueAmounts = responseData.reduce((accumulator, invoice) => {
                      accumulator[invoice.InvoiceNo] = {
                        TotalDueAmount: invoice.TotalDueAmount
                      };
                      return accumulator;
                    }, {});
                    setMappedTotalDueAmount(mappedTotalDueAmounts);
                    const mappedPendingInvoiceDetails = responseData.reduce((accumulator, invoice) => {
                      accumulator[invoice.InvoiceNo] = invoice; // Store the entire invoice object
                      return accumulator;
                    }, {});
                    setMappedPendingInvoiceDetails(mappedPendingInvoiceDetails);
                    setAmountFormValues(prevState => ({
                      ...prevState,
                      amount: {
                          ...prevState.amount,
                          value: amountToBePaid,
                      },
                    }));

                    if(amountToBePaid > 0) {
                      setTapPayload(prevState => ({
                        ...prevState,
                        paymentData: {
                          ...prevState.paymentData,
                          number: number,
                          amount: amountToBePaid
                        },
                        extraInformation: {
                          ...prevState.extraInformation,
                          totalAmount: amountToBePaid
                        }
                      }));
        
                      setApplePayload(prevState => ({
                        ...prevState,
                        paymentData: {
                          ...prevState.paymentData,
                          number: number,
                          amount: amountToBePaid
                        },
                        extraInformation: {
                          ...prevState.extraInformation,
                          totalAmount: amountToBePaid
                        }
                      }));
                    }
                    setLoading(false);
                  } else {
                    setLoading(false);  
                  }
                }
              })
              .catch(() => {
                setSubLoading(false)
              })
            } else {
              setLoading(false);
            }
            Storage.clear("genericAPIError");
          }
        }
      })
      .catch((error) => {
        Storage.clear("genericAPIError");
        setLoading(false);
      });
  };

  useEffect(() => {
    // Check if state exists in history.location and set the data accordingly
    if (history?.location?.state && history?.location?.state?.formValues) {
      const formData = history?.location?.state?.formValues;
      Storage.set("billPaymentNumber", formData?.phone?.value, true);
      fetchPlans(formData?.phone?.value);
    }
  }, [Translations.activeLang]); // eslint-disable-line react-hooks/exhaustive-deps

  const showPaymentOnly = (data) => {
    setShowPayment(data);
  }

  const selectedPaymentMethod = (data) => {
    Storage.set("SelectedPaymentMethodTemp", data);
  }

  const downloadBill = (invoice_number) => {
    let firebase_param = {
      bill_number: invoice_number,
    }
    FirebaseAnalytics.download_bill(firebase_param);
    BillPaymentService.billDownloadByInvoice(invoice_number)
    .then((res) => {
      saveAs(res.data, `invoice_${invoice_number}.pdf`);
    })
    .catch((res) => {
      // Do nothing
    })
  }
  
  const getConvertedBillDate = (dateStringStart, dateStringEnd, lang) => {  
    if (Translations.activeLang === "en") {
      moment.locale("en-ca");
    }
		if (Translations.activeLang === "ar") {
      moment.locale("ar-sa");
    }
    const start = moment(dateStringStart);
    const end = moment(dateStringEnd);
    const formattedStart = start.format('DD MMM');
    const formattedEnd = end.format('DD MMM YYYY');
    return `${formattedStart} - ${formattedEnd}`
  }

  const handleToggle = async (recentInvoice) => {
    setSubLoading(true);
    if (expandedInvoice === recentInvoice) {
        setExpandedInvoice(null);
    } else {
        setExpandedInvoice(recentInvoice);
        // Call API to fetch invoice details
        BillPaymentService.billByInvoice(recentInvoice)
        .then((response) => {
          if (response) {
            setSubLoading(false)
            let data = response.data;
            if(data && data?.PendingInvoiceDetails?.length) {
              let invoicedata = data.PendingInvoiceDetails[0];
              setInvoiceDetails(invoicedata);
            }
          }
        })
        .catch(() => {
          setSubLoading(false)
        })
    }
  };

  const updateAmountInput = (amountObj) => {
    setAmountFormValues(prevState => ({
        ...prevState,
        amount: {
            ...prevState.amount,
            value: amountObj.value,
        }
    }));
  }

  const updateAmountField = (amountObj) => {
    setAmountFormValues(prevState => ({
      ...prevState,
      amount: {
          ...prevState.amount,
          value: amountObj.value,
          valid: amountObj.valid,
          touched: amountObj.touched,
          error: amountObj.error
      },
    }));
    setTapPayload(prevState => ({
      ...prevState,
      paymentData: {
        ...prevState.paymentData,
        amount: amountObj.value
      },
      extraInformation: {
        ...prevState.extraInformation,
        totalAmount: amountObj.value
      }
    }));

    setApplePayload(prevState => ({
      ...prevState,
      paymentData: {
        ...prevState.paymentData,
        amount: amountObj.value
      },
      extraInformation: {
        ...prevState.extraInformation,
        totalAmount: amountObj.value
      }
    }));
  }

  const renderErrorMsg = (errorMsg) => {
    // "Enter an amount between 25 SR and 2500 SR",
    // Please enter the amount you wish to pay.
    let parsedError = ""
    parsedError = Translations.keys[`stf_bill_payment_amount_enter_${errorMsg}`];

    return parsedError;
  }

  const getSliderData = (modalKey) => {
    const poModalKey = modalKey;
    let business = Storage.get("business", true);
    let poModalData = null;
    if (business) {
      business = JSON.parse(business);
      if (business[poModalKey]) {
        poModalData = business[poModalKey]
      }
    }
    return poModalData
  }

  const handleModal = (e) => {
    e.stopPropagation();
    setOpenModal((prev) => !prev);
  };

  const handleModalData = (e, type) => {
    const sliderData = getSliderData(type);
    if (sliderData) {
      setInfoModalDetails({
        "imagesFolder": "information_popup_images",
        "sliderData": sliderData
      });
      handleModal(e);
    }
  };

  const getVatPercentage = () => {
    let vat_percentage = JSON.parse(Storage.get("business", true))[
      "vat_percentage"
    ];
    return vat_percentage || 0
  }

  const DateToMonth = (date) => {
    // Convert the date to the full month name
    const month = moment(date).format('MMMM');
    return month;
  };

  const getFinalPrice = (data) => {
    if(data?.PlanCardDiscountedPrice < data?.PlanCardPrice)
    { 
      return Helpers.formatWithPORemoveCommas(data?.PlanCardDiscountedPrice)
    } else {
      return Helpers.formatWithPORemoveCommas(data?.PlanCardPrice)
    }
  }

  const fetchPlans = (number) => {
    // Fetch the details for Current & Change Plan
    let currentProductCode = Helpers.checkForProductDetail("name", CONSTANTS.REGULAR_POSTPAID_PRODUCT_ATTR);
    let countryCode = Helpers.getCountryCodePO() || "";
    let phoneNumber = `${countryCode}${number?.replace(/^0+/, '')}`;
    BillPaymentService.getAllPlans(currentProductCode?.code, phoneNumber)
    .then((res) => {
      if(res.data.PreDefinedBundles) {
        const filteredPlansData = res.data.PreDefinedBundles?.filter(bundle => String(bundle.ProductCode) === String(currentProductCode?.code));
        const allPlans = filteredPlansData[0].PreDefinedBundle;
        setAllPlans(allPlans);
        getBillList(phoneNumber);
      }
    })
    .catch((res) => {
      // Do nothing
    })
  }

  const getPlanData = (data) => {
    let planData = Helpers.filterByPlanType(data?.Plan, "DATA");
    let dataVal = 0;
    if(planData?.length) {
      dataVal = storefront.getTransformedPlanTypeValues(planData[0]?.Value, planData[0]?.Unit)
    }
    return dataVal === -1 ? Translations.keys["free_addons_unlimited"] : dataVal
  }

  const getPlanImage = (data) => {
    if(data?.PlanCode) {
      return Helpers.getPOImageCommon("stf_predefined_img_for_mobile", data?.PlanCode.toLowerCase(), Translations.activeLang, "")
    }
    return ""
  }
  
  const renderChangePlanMob = (pplCode = "", invoiceDtl) => {
    let content = "";
    if(allPlans) {
      let changePlanCode = pplCode;
      let currentPlanCode = invoiceDtl?.PricePlanCode;
      let filteredChangePlan = allPlans?.filter(plan => plan.PlanCode === changePlanCode)?.[0];
      let filteredCurrentPlan = allPlans?.filter(plan => plan.PlanCode === currentPlanCode)?.[0];

      let currentPlan = (
      <div style={{backgroundImage: `url("${getPlanImage(filteredCurrentPlan)}")`}}>
        <div className="sim-bill-payment-details">
          <div>{translationKeys["stm_bill_payment_choosen_plan"]}</div>
          <div>
            <span>
              {getPlanData(filteredCurrentPlan)}{" "}{translationKeys["stm_general_data_unit"]}
            </span>
            <span>
              {getFinalPrice(filteredCurrentPlan)}{" "}{translationKeys["stm_general_currency"]}
            </span>
          </div>
        </div>
      </div>
      );

      if (pplCode === null || pplCode === '' || pplCode === undefined) {
        content = (<>
          <span>{`${translationKeys["stm_switch_description_same_plan"]} ${invoiceDtl?.FromDate && DateToMonth(invoiceDtl.FromDate)}!`}</span>
          <div className="sim-bill-payment-plans single-sim-bill-payment-plan">
            {currentPlan}
          </div>
        </>);
      } else {
        content = (
        <>
          <span>{`${translationKeys["stm_switch_description_lower_plan"]} ${invoiceDtl?.FromDate && DateToMonth(invoiceDtl.FromDate)}! ${translationKeys["stm_switch_description_saved"]} ${invoiceDtl.OptimaSavings} ${translationKeys["stm_general_currency"]}`}</span>
          <div className="sim-bill-payment-plans">
            {currentPlan}
            <div style={{backgroundImage: `url("${getPlanImage(filteredChangePlan)}")`}}>
              <div className="sim-bill-payment-details">
                <div>{translationKeys["stm_bill_payment_best_plan"]}</div>
                <div>
                  <span>
                    {getPlanData(filteredChangePlan)}{" "}{translationKeys["stm_general_data_unit"]}
                  </span>
                  <span>
                    {getFinalPrice(filteredChangePlan)}{" "}{translationKeys["stm_general_currency"]}
                  </span>
                </div>
              </div>
            </div>
            <img src={ChangePlanArrow} alt="" />
          </div>
        </>);
      }
    }
    return content;
  }

  const renderChangePlan = (pplCode = "", invoiceDtl) => {
    let content = "";
    if(allPlans) {
      let changePlanCode = pplCode;
      let currentPlanCode = invoiceDtl?.PricePlanCode;
      let filteredChangePlan = allPlans?.filter(plan => plan.PlanCode === changePlanCode)?.[0];
      let filteredCurrentPlan = allPlans?.filter(plan => plan.PlanCode === currentPlanCode)?.[0];

      let currentPlan = (
      <div>
        <img src={getPlanImage(filteredCurrentPlan)} alt="" className="change-plan-img"/>
        <div className="sim-bill-payment-details-fi">
          <div>{translationKeys["stm_bill_payment_choosen_plan"]}</div>
          <div>
            <span>
              {getPlanData(filteredCurrentPlan)}{" "}{translationKeys["stm_general_data_unit"]}
            </span>
            <span>
              {getFinalPrice(filteredCurrentPlan)}{" "}{translationKeys["stm_general_currency"]}
            </span>
          </div>
        </div>
      </div>
      );

      if (pplCode === null || pplCode === '' || pplCode === undefined) {
        content = (<>
          <span>{`${translationKeys["stm_switch_description_same_plan"]} ${invoiceDtl?.FromDate && DateToMonth(invoiceDtl.FromDate)}!`}</span>
          <div className="sim-bill-payment-plans-fi single-sim-bill-payment-plan-fi">
            {currentPlan}
          </div>
        </>);
      } else {
        content = (
        <>
          <span>{`${translationKeys["stm_switch_description_lower_plan"]} ${invoiceDtl?.FromDate && DateToMonth(invoiceDtl.FromDate)}! ${translationKeys["stm_switch_description_saved"]} ${invoiceDtl.OptimaSavings} ${translationKeys["stm_general_currency"]}`}</span>
          <div className="sim-bill-payment-plans-fi">
            {currentPlan}
            <div>
              <img src={getPlanImage(filteredChangePlan)} alt="" className="change-plan-img"/>
              <div className="sim-bill-payment-details-fi">
                <div>{translationKeys["stm_bill_payment_best_plan"]}</div>
                <div>
                  <span>
                    {getPlanData(filteredChangePlan)}{" "}{translationKeys["stm_general_data_unit"]}
                  </span>
                  <span>
                    {getFinalPrice(filteredChangePlan)}{" "}{translationKeys["stm_general_currency"]}
                  </span>
                </div>
              </div>
            </div>
            <img src={ChangePlanArrow} alt="" className="arrow-img"/>
          </div>
        </>);
      }
    }
    return content;
  }

  let content = (
    <div className="stf-deactivation-bill-wrapper">
      <StorefrontTitle
        title={translationKeys["stm_bill_payment_heading"]}
        desc={translationKeys["stm_bill_payment_desc"]}
      />
      {loading ? <SpinnerTimeLoader /> :
      <>
      {!showPayment ?
        <div className="sim-deactivation-bill-container">
          {invoicesList.length > 0 ?
            <>
              {invoicesList.map((invoice) => {
                return <div className={`sim-deactivation-bill ${Helpers.isSafari() ? "safari" : ""}`} key={invoice?.InvoiceNo}>
                <div className="sim-deactivation-bill-content">
                  <div className="sim-deactivation-bill-header">
                    <div>
                        <div>{translationKeys["stm_bill_payment_bill"]}{" "}#{invoice?.InvoiceNo}</div>
                        <span>{mappedPendingInvoiceDetails[invoice.InvoiceNo]?.FromDate && mappedPendingInvoiceDetails[invoice.InvoiceNo]?.ToDate ? <>{getConvertedBillDate(mappedPendingInvoiceDetails[invoice.InvoiceNo]?.FromDate, mappedPendingInvoiceDetails[invoice.InvoiceNo]?.ToDate, Translations.activeLang)}</> : ""}</span>
                        {/* STARTS: Hide the below div if collapsable is Closed */}
                        {expandedInvoice === invoice.InvoiceNo ?
                        <div 
                          className="sim-deactivation-download-bill" 
                        >
                          <button 
                            onClick={() => {
                              downloadBill(invoice?.InvoiceNo)
                            }}
                          >
                            {translationKeys["stm_bill_payment_download_bill"]}
                          </button>
                        </div> : ""}
                        {/* ENDS: Hide the below div if collapsable is Closed */}

                    </div>
                    <div className="bill-status-container">
                      <div className="bill-status">
                        {translationKeys["stm_bill_payment_unpaid"]}
                      </div>
                      <img src={expandedInvoice === invoice.InvoiceNo ? BillOpenIcon : BillClosedIcon} alt="" onClick={() => handleToggle(invoice?.InvoiceNo)}/>
                    </div>                    
                  </div>

                  <hr />

                  {/* Collapsable Section Main Starts Here */}
                  {expandedInvoice === invoice.InvoiceNo ?
                  <div
                    className="sim-deactivation-bill-details" 
                  >
                    {subLoading ?
                    <SpinnerTimeLoader /> :
                    <>
                      {Helpers.isMobile600() ?
                        <div className="sim-bill-payment-change-plan">
                          {invoiceDetails && renderChangePlanMob(invoiceDetails?.OptimaPplCode, invoiceDetails)}
                        </div> : 
                        <div className="sim-bill-payment-change-plan-fi">
                          {invoiceDetails && renderChangePlan(invoiceDetails?.OptimaPplCode, invoiceDetails)}
                        </div>
                      }
                      <hr />
                      <div className="sim-deactivation-bill-summary">
                        <div className="sim-deactivation-bill-info-header">
                          <div>{translationKeys["stm_bill_payment_plans"]}</div>
                          <div>{translationKeys["stm_bill_payment_subtotal"]}</div>
                        </div>
                        <div className="sim-deactivation-bill-info">
                          <div>{translationKeys[`general_plan_name_${Helpers.processLokaliseKey(invoiceDetails.PricePlanCode)}`]}</div>
                          <div>{Helpers.formatWithPORemoveCommas(invoiceDetails.MonthlySubFees)}{" "}{translationKeys["stm_general_currency"]}</div>
                        </div>
                        {mappedPendingInvoiceDetails[invoice.InvoiceNo]?.OutOfBundleUsage?.length > 0 ? 
                          mappedPendingInvoiceDetails[invoice.InvoiceNo]?.OutOfBundleUsage?.map((item, index) => {
                            return <div className="sim-deactivation-bill-info" key={index}>
                              <div>{item?.Type}</div>
                              <div>{Helpers.formatWithPORemoveCommas(item.UsageBasedSubFees)}{" "}{translationKeys["stm_general_currency"]}</div>
                            </div>
                          })
                        : null}
                      </div>
                      <hr />
                      <div className="sim-pay-bill-see-details">
                        <div className="sim-pay-bill-see-details-header">
                          <span>{translationKeys["stm_bill_payment_see_bill_details"]}</span>
                          <img src={subExpandedInvoice === invoice.InvoiceNo ? BillOpenIcon : BillClosedIcon} alt="" onClick={() => {
                            if (subExpandedInvoice === invoice.InvoiceNo) {
                              setSubExpandedInvoice(null);
                            } else {
                              setSubExpandedInvoice(invoice.InvoiceNo);
                            }
                          }}/>
                        </div>
                        {subExpandedInvoice === invoice.InvoiceNo ?
                        <div className="sim-pay-bill-see-details-content">
                          <div className="sim-pay-bill-see-details-content-row">
                            <div className="sim-pay-bill-see-details-content-row-text">{translationKeys["stm_bill_payment_total_month_charges"]}{" "}<span>{translationKeys["stm_bill_payment_vat_excl"]}</span></div>
                            <div>{Helpers.formatWithPORemoveCommas(invoiceDetails?.TotalMonthlyCharges)}{" "}{translationKeys["stm_general_currency"]}</div>
                          </div>

                          <div className="sim-pay-bill-see-details-content-row optima-savings">
                            <div className="sim-pay-bill-see-details-content-row-text-icon">
                              <div className="sim-pay-bill-see-details-content-row-text">{translationKeys["stm_bill_payment_optima_savings"]}</div> 
                              <img 
                                src={QuestionCircleIcon} alt="" 
                                onClick={(e) => {
                                  handleModalData(e, "about_optima_popup_json")}
                                }
                              />
                            </div>
                            <div>{Helpers.formatWithPORemoveCommas(invoiceDetails?.OptimaSavings)}{" "}{translationKeys["stm_general_currency"]}</div>
                          </div>

                          <div className="sim-pay-bill-see-details-content-row">
                            <div className="sim-pay-bill-see-details-content-row-text">{translationKeys["stm_bill_payment_taxable_amount"]}</div>
                            <div>{Helpers.formatWithPORemoveCommas(invoiceDetails?.TaxableAmount)}{" "}{translationKeys["stm_general_currency"]}</div>
                          </div>

                          <div className="sim-pay-bill-see-details-content-row">
                            <div className="sim-pay-bill-see-details-content-row-text">{translationKeys["stm_bill_payment_vat"]}{" "}{getVatPercentage() ? ` (${getVatPercentage()}%) ` : null}</div>
                            <div>{Helpers.formatWithPORemoveCommas(invoiceDetails?.TaxAmount)}{" "}{translationKeys["stm_general_currency"]}</div>
                          </div>

                          <div className="sim-pay-bill-see-details-content-row">
                            <div className="sim-pay-bill-see-details-content-row-text-icon">
                              <div className="sim-pay-bill-see-details-content-row-text">{translationKeys["stm_bill_payment_recieved_pay"]}</div>
                              <img 
                                src={QuestionCircleIcon} alt=""
                                onClick={(e) => {
                                  handleModalData(e, "received_payments_popup_json")}
                                }
                              />
                            </div>
                            <div>{Helpers.formatWithPORemoveCommas(invoiceDetails?.ReceivedPayment)}{" "}{translationKeys["stm_general_currency"]}</div>
                          </div>

                          <div className="sim-pay-bill-see-details-content-row">
                            <div className="sim-pay-bill-see-details-content-row-text-icon">
                              <div className="sim-pay-bill-see-details-content-row-text">{translationKeys["stm_bill_payment_previous_balance"]}{" "}<span>{translationKeys["stm_bill_payment_vat_inc"]}</span></div> 
                              <img 
                                src={QuestionCircleIcon} alt=""
                                onClick={(e) => {
                                  handleModalData(e, "previous_balance_popup_json")}
                                }
                              />
                            </div>
                            <div>{Helpers.formatWithPORemoveCommas(invoiceDetails?.PreviousBalance)}{" "}{translationKeys["stm_general_currency"]}</div>
                          </div>
                        </div> : ""}
                      </div>
                    </>}
                  </div>
                  : ""}
                  {/* Collapsable Section Main Ends Here */}
                
                  <div className="sim-deactivation-bill-sub-header">
                    <div>
                      <div>
                        {translationKeys["stm_bill_payment_total_due_amount"]}
                        <span>{translationKeys["stm_bill_payment_vat_inc"]}</span>
                      </div>
                      {Helpers.formatWithPORemoveCommas(mappedTotalDueAmount[invoice?.InvoiceNo]?.TotalDueAmount || 0)}{" "}{translationKeys["stm_general_currency"]}
                    </div>
                  </div>
                
                </div>
                <img src={ZigZag} alt=""/>
              </div>
            
              })}
            </>
            : "" }
        </div> : ""}

        {!showPayment ?
        <div className="storefront-amount-field-container">
            <label>{translationKeys["stm_bill_payment_amt"]}</label>
            <div className="phone-field-with-tick amount-field-with-tick">
                <SharedAmount
                  name="amount"
                  id="amount"
                  classname={`storefront-amount-field tickIcon walletIcon ${amountFormValues?.amount.error && !amountFormValues?.amount.valid ? "error-amt" : ""}`}
                  amount={amountFormValues?.amount}
                  updateAmountField={updateAmountField}
                  updateAmountInput={(e) => updateAmountInput(e)}
                  placeholder={translationKeys["stm_bill_payment_amount_placeholder"]}
                />
                <img src={BillWalletIcon} className="imgLeft" alt=""/>
            </div>
            {amountFormValues?.amount?.valid && !amountFormValues?.amount?.touched ?
            <div className="hint-section">
              {translationKeys["stf_bill_payment_amount_enter_required"] || "Please enter the amount you wish to pay."}
            </div> : ""}
            {amountFormValues?.amount.error && !amountFormValues?.amount.valid ? <span className="hint-section error-msg">{renderErrorMsg(amountFormValues?.amount.error)}</span> : ""}
        </div> : ""}

        <CommonPayment
          selectedPaymentMethod={(data) => selectedPaymentMethod(data)} 
          showPaymentOnly={(data) => showPaymentOnly(data)} 
          tapPayload={tapPayload}
          applePayload={applePayload}
          paymentDisabled={!amountFormValues.amount.valid}
        />
      </>}
    </div>

  );
  if (props.loading) {
    content = <SpinnerTimeLoader />
  }
  return <>
    {content}
    {openModal &&
      <ModalWrapper handleToggleModal={handleModal}>
        <ContentSlider
          imagesFolder={infoModalDetails?.imagesFolder}
          sliderData={infoModalDetails?.sliderData}
          closeModal={handleModal}
        />
      </ModalWrapper>
    }
  </>;
};
export default BillPaymentBills;
